<div class="bg-m1 flex h-full items-center justify-center">
  <div class="flex flex-col items-center">
    <div>
      <m-completed-ring></m-completed-ring>
    </div>

    <div
      data-cy="orgOwnerChangedTitle"
      class="text-s2 mt-5 select-none text-2xl font-semibold"
      >{{ pageTitle }}</div
    >
    <div class="text-s1 mt-5 text-center text-base">
      <span class="font-semibold">
        {{ orgName }}
      </span>
      owner changed to
      <span class="font-semibold">
        {{ newOrgOwner }}
      </span>
    </div>
  </div>
</div>
